import script from "./CardOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./CardOffer.vue?vue&type=script&setup=true&lang=js"

import "./CardOffer.vue?vue&type=style&index=0&id=b1609906&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1609906"]])

export default __exports__